/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';

import ContentWrapper from '../../../../components/ContentWrapper';
import { GrayCard } from '../../../../components/card/Card';
import PrivacyCard from '../../../../components/card/PrivacyCard';
import { HealthInfoPolicyStatus, DependentAuthPolicyStatus } from './PolicyStatus';
import DoNotConsentModal, { WithdrawName } from '../../../../components/modal/DoNotConsentModal';
import { selectors as ownerSelectors } from '../../../../redux/ducks/owners';
import * as selectors from '../../../redux/reduxSelectors';
import { actions as systemModalActions } from '../../../../redux/ducks/systemModal';
import { selectors as consentSelectors } from '../../../../redux/ducks/consent';
import { selectors as policySelectors } from '../../../../redux/ducks/policy';
import { ConsentPayloadInterface, ConsentPolicyName } from '../../../../../models/ConsentModel';
import { FormattedMessage } from 'react-intl';

function mapStateToProps(state) {
  const profileId = selectors.getActiveProfileId(state);
  const activeProfile = selectors.getActiveProfile(state);
  const activeOwnerProfiles = ownerSelectors.getActiveOwnersForProfile(profileId, state);

  return {
    isMainProfile: profileId === selectors.getMainProfileId(state),
    hasUser: activeProfile.hasUser,
    hasSoleAccess: activeOwnerProfiles.length === 1,
    consents: consentSelectors.getAll(state, profileId),
    getPolicy: (name) => {
      return policySelectors.getPolicyByName(state, name);
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (ModalComponent) => {
      dispatch(systemModalActions.show(ModalComponent));
    },
  };
}

interface Props {
  isMainProfile: boolean;
  hasSoleAccess: boolean;
  consents: ConsentPayloadInterface;
  showModal(data): void;
  getPolicy(name): any;
  hasUser: boolean;
}

class ProfilePrivacyContent extends React.Component<Props, {}> {

  handleOnWithdrawConsent = (consentName) => {
    const { isMainProfile, hasSoleAccess, consents, showModal } = this.props;

    const policyName = consents[consentName].consent_policy_name;
    let withdrawName = '';

    if (isMainProfile) {
      withdrawName = WithdrawName.afterSetup;
    } else if (hasSoleAccess) {
      withdrawName = WithdrawName.afterDependentSetupSoleAccess;
    } else {
      withdrawName = WithdrawName.afterDependentSetupSharedAccess;
    }

    showModal(<DoNotConsentModal withdrawName={withdrawName} policyName={policyName} isShared={!hasSoleAccess} />);
  }

  render() {
    const { isMainProfile, consents, showModal, getPolicy, hasUser } = this.props;
    const allowWithdraw = isMainProfile || !hasUser;
    const requiresLegalAuth = !hasUser;

    return (
      <ContentWrapper>
        <GrayCard>
          <FormattedMessage id="profileprivacy.message.text">
            {
              (msg: string) => (
                <PrivacyCard
                  title=""
                  subTitle="privacy.privacyBlock.general.teaser"
                  summary={msg}
                  isCollapsible={true}
                  defaultCollapsed={true}
                  allowWithdraw={allowWithdraw}
                />
              )
            }
          </FormattedMessage>
        </GrayCard>

        <HealthInfoPolicyStatus
          allowWithdraw={allowWithdraw}
          consentData={consents[ConsentPolicyName.healthInfo]}
          onWithdrawConsent={() => {
            this.handleOnWithdrawConsent(ConsentPolicyName.healthInfo);
          }}
        />

        {
          requiresLegalAuth && (
            <DependentAuthPolicyStatus
              consentData={consents[ConsentPolicyName.dependentAuth]}
              onWithdrawConsent={() => {
                this.handleOnWithdrawConsent(ConsentPolicyName.dependentAuth);
              }}
            />
          )
        }

      </ContentWrapper>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePrivacyContent);
